window.addEventListener('load', function() {
    const _throttle = require('lodash.throttle'); // Import the throttle function

    // Function to initialize the ticker
    function initializeTicker() {
        const tickerContainers = document.querySelectorAll('.ticker-panel, .ticker-header-panel');

        tickerContainers.forEach(function(tickerContainer) {
            const animatedTickers = tickerContainer.querySelectorAll('.animate-ticker-x');

            for (const animatedTicker of animatedTickers) {
                const tickerWidth = animatedTicker.scrollWidth;
                const speed = 20; // Set speed to 10px per second
                const duration = tickerWidth / speed; // Calculate duration in seconds

                if (animatedTicker.classList.contains('absolute')) {
                    animatedTicker.style.left = tickerWidth + 'px';
                }

                // Set the animation duration dynamically based on largest content width
                animatedTicker.style.animationDuration = `${duration}s`;
            }
        });
    }

    // Initialize on page load
    initializeTicker();

    // Reinitialize on window resize with throttling
    window.addEventListener('resize', _throttle(initializeTicker, 300));
});
